import { documentFormatted } from "./documentFormatted";
import { ExtractItem } from "./extractDescription";

export default function getTransactionDocuments(
	transaction: ExtractItem,
	formated?: boolean,
) {
	const { response, data, direction } = transaction;

	let beneficiary = "";
	let payer = "";

	if (transaction.type.toLowerCase().includes("p2p")) {
		payer = response?.proof?.payer?.holder?.document;
		beneficiary = response?.proof?.beneficiary?.holder?.document;
	}

	if (transaction.type.includes("PAGBANK_PAYMENT")) {
		payer = data?.payer?.document;
		beneficiary = data?.beneficiary?.document;
	}

	if (transaction.type.toLowerCase().includes("pix")) {
		payer =
			response?.proof?.payer?.holder?.document ||
			response?.payer?.holder?.document;
		beneficiary =
			response?.proof?.beneficiary?.holder?.document ||
			response?.beneficiary?.holder?.document;
	}

	if (transaction.type == "INTERNAL_TAX") {
		payer = response?.payer?.document;
		beneficiary = response?.beneficiary?.document;
	}

	if (transaction.type == "TED") {
		payer = response?.proof?.payer?.holder?.document;
		beneficiary = response?.proof?.beneficiary?.holder?.document;
	}

	if (transaction.type == "payment") {
		payer = "";
		beneficiary = response?.beneficiary?.document;
	}
	const newTypes = [
		"PIX_STATIC",
		"PIX_DYNAMIC",
		"PIX_KEY",
		"PIX_MANUAL",
		"INTERNAL_WALLET_TRANSACTION",
		"PIX_COPY_AND_PASTE",
	];

	if (
		newTypes.some((type) => transaction.type.includes(type)) &&
		direction == "in"
	) {
		beneficiary = "";
		payer =
			response?.data?.counterparty?.tax_number || response?.payer?.document;
	}

	if (
		newTypes.some((type) => transaction.type.includes(type)) &&
		direction == "out"
	) {
		beneficiary =
			response?.data?.counterparty?.tax_number ||
			response?.beneficiary?.document;
		payer = "";
	}

	beneficiary = beneficiary
		? formated
			? documentFormatted(beneficiary)
			: beneficiary
		: "********";
	payer = payer ? (formated ? documentFormatted(payer) : payer) : "********";

	return { beneficiary, payer };
}
